import { enforce, test } from "vest";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";
import { trans } from "@/service/i18n/i18n";

export function createTextareaFieldValidationSuite(
  definition: TextareaField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue) as string;

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(value).isString().isNotEmpty();
    });
  }

  if (definition.min && value.length > 0) {
    test(
      createFieldName(definition),
      trans("form_validation.min", { value: definition.min }),
      () => {
        enforce(value).longerThan(definition.min - 1);
      },
    );
  }
}
